import { createContext, useContext } from 'react';

import { BannerContext } from '@kc-console/context';

/**
 * BannerProvider가 주입한 Banner를 useContext(BannerContext ?? DefaultBannerContext)로 꺼내 마운트합니다.
 * hosts/baguni에서 BannerContext가 제거되는 경우 에러를 방지하기 위해 stubContext로 처리합니다.
 */

const stubContext = createContext({});

const BannerRenderer = () => {
  const { Banner } = useContext(BannerContext ?? stubContext) ?? {};

  if (!Banner) return null;

  return <Banner />;
};

export default BannerRenderer;
